
class VideoModalClass{
    constructor(){
        this.main = document.getElementById('video_modal');
        
        this._video = this.main.querySelector('video');
        this._closeBtn = this.main.querySelector('.close_btn');

        this._isPlaying = false;

        this._closeBtn.addEventListener('click', this._onClickCloseBtn.bind(this));
        this.main.querySelector('.modal__content').addEventListener('click', e => e.stopPropagation());
        this.main.addEventListener('click', this._onClickCloseBtn.bind(this));
        this._video.addEventListener('click', this._onClickVideo.bind(this));
        this._video.addEventListener('ended', this._onVideoEnded.bind(this));
        this._video.addEventListener('play', this._onVideoPlay.bind(this));
        this._video.addEventListener('pause', this._onVideoPause.bind(this));
    }

    show(videoUrl){
        document.body.classList.add('block-scroll');
        this.main.classList.add('modal--show');
        
        this._video.src = videoUrl;
        this._video.play();

        this._isPlaying = true;

        setTimeout(()=>{
            this.main.classList.add('modal--anim');
        }, 100);
    }
    
    hide(){
        this.main.classList.remove('modal--anim');
        
        this._video.pause();
        this._isPlaying = false;

        setTimeout(()=>{
            this.main.classList.remove('modal--show');
            document.body.classList.remove('block-scroll');
        }, 750);
    }

    _onClickCloseBtn(e){
        e.preventDefault();
        this.hide();
    }

    _onVideoEnded(e){
        this._video.currentTime = 0;
    }

    _onVideoPlay(e){
        this._isPlaying = true;
    }

    _onVideoPause(e){
        this._isPlaying = false;
    }

    _onClickVideo(e){
        if(this._isPlaying){
            this._isPlaying = false;
            this._video.pause();
        }else{
            this._isPlaying = true;
            this._video.play();
        }
    }
}

const VideoModal = new VideoModalClass();
Object.seal(VideoModal);

export default VideoModal;